module.exports = __webpack_public_path__ + "img/mail_purple.3e89c99c.svg";